import React from "react";
import { useAuth0 } from "../../auth/react-auth0-spa";
import { useAppContext } from "../../contexts/AppContext";
import { Menu, MenuItem } from "carbon-react/lib/components/menu";
import { Link, useLocation } from "react-router-dom";
import appRoutes from "./appRoutes";
import NavigationBar from "carbon-react/lib/components/navigation-bar";

const NavBar = () => {
  const { isAuthenticated } = useAuth0();
  const { agentEntitlement } = useAppContext();
  const location = useLocation();

  return (
    <NavigationBar>
      <Menu as="primary" className="nav">
        {isAuthenticated && (
          <>
            {agentEntitlement && agentEntitlement.tabs.showManageUsers && (
              <MenuItem
                {...(location &&
                (location.pathname === appRoutes.users ||
                  location.pathname.startsWith(appRoutes.user))
                  ? { selected: true }
                  : {})}
              >
                <Link id="navbarLink_users" to={appRoutes.users}>
                  Manage users
                </Link>
              </MenuItem>
            )}
            {agentEntitlement && agentEntitlement.tabs.showManageAgents && (
              <MenuItem
                {...(location && location.pathname === appRoutes.agents
                  ? { selected: true }
                  : {})}
              >
                <Link id="navbarLink_agents" to={appRoutes.agents}>
                  Manage agents
                </Link>
              </MenuItem>
            )}
            {agentEntitlement && agentEntitlement.tabs.showAuditLogs && (
              <MenuItem
                {...(location && location.pathname === appRoutes.audit
                  ? { selected: true }
                  : {})}
              >
                <Link id="navbarLink_audit" to={appRoutes.audit}>
                  Audit logs
                </Link>
              </MenuItem>
            )}
          </>
        )}
      </Menu>
    </NavigationBar>
  );
};

export default NavBar;
